import React, { useEffect, useState } from "react"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from "reactstrap"
import styles from "./ActiveProducts.module.scss"
import ManageTable from "../../../../views/Manage/ManageTable"
import { Loader } from "react-feather"
import CustomDropdown from "../../../common/Dropdown/CustomDropDown"

const ActiveProducts = () => {
  const [loading, setLoading] = useState(true)

  // State to track dropdown open state for each row
  const [dropdownOpen, setDropdownOpen] = useState({})

  // Function to toggle dropdown for a specific row
  const toggleDropdown = (rowId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId],
    }))
  }

  const data = [
    {
      id: 1,
      name: "Blue Colored Headphones",
      sku: "Example123",
      productImg: require("../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
      dateCreated: "08/06/2024",
      price: "$33.33",
      shipping: "$1",
      featuredPrice: "$38.33",
      competitivePrice: "$34.00",
      lowestPrice: "$30.33",
      stock: "300",
      moq: '100',
      bulkPrice: '$30.00'
    },
    {
      id: 2,
      name: "Blue Colored Headphones",
      sku: "Example123",
      productImg: require("../../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
      dateCreated: "08/06/2024",
      price: "$33.33",
      shipping: "$1",
      featuredPrice: "$38.33",
      competitivePrice: "$34.00",
      lowestPrice: "$30.33",
      stock: "300",
      moq: '100',
      bulkPrice: '$30.00'
    },
  ]

  const columns = [
    {
      name: "Sr. no.",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Product Image",
      cell: (row) => <img src={row.productImg} alt={row.name} className={styles.productImg} />,
      minWidth: "140px",
    },
    {
      name: "Product Name",
      selector: (row) => row.name,
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "SKU",
      selector: (row) => row.sku,
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "Date Created",
      selector: (row) => row.dateCreated,
      sortable: true,
      minWidth: "140px",
    },
    {
      name: "Price + Shipping fee",
      cell: (row) => (
        <div className={styles.priceContainer}>
          <div className={styles.priceShippingRow}>
            <span className={styles.price}>{row.price} </span> + {row.shipping}
          </div>
          <div className={styles.priceDetails}>
            Featured price: {row.featuredPrice}
            <br />
            Competitive: {row.competitivePrice}
            <br />
            Lowest price: {row.lowestPrice}
          </div>
        </div>
      ),
      grow: 2,
      minWidth: "180px",
    },
    {
      name: "Stock",
      selector: (row) => row.stock,
    },
    {
        name: "MOQ",
        selector: (row) => row.moq,
      },
      {
        name: "Bulk Price (per unit)",
        selector: (row) => row.bulkPrice,
        minWidth: "160px",
      },
    {
      name: "Action",
      cell: (row) => (
        <Dropdown isOpen={dropdownOpen[row.id]} toggle={() => toggleDropdown(row.id)} className={styles.actionDropdown}>
          <DropdownToggle caret className={styles.dropdownButton}>
            Action
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem>Edit</DropdownItem>
            <DropdownItem>Deactivate</DropdownItem>
            <DropdownItem>Delete</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ),
    },
  ]

  useEffect(() => {
    setLoading(false)
  }, [])

  return (
    <div className={styles.activeProductsContainer}>
      <div className={styles.totalProducts}>
        <div className={styles["total"]}>Total Products: 300</div>
        <div className="d-flex gap-2 align-items-center">
          <div className="border border-secondary rounded px-2">
            <CustomDropdown title="Print" />
          </div>
          <div className="border border-secondary rounded px-2">
            <CustomDropdown title="Export" />
          </div>
          <div className="border border-secondary rounded px-2">
            <CustomDropdown title="View history" />
          </div>
          <div className="border border-secondary rounded px-2">
            <CustomDropdown title="Bulk Edit" />
          </div>
        </div>
      </div>

      {loading ? <Loader /> : <ManageTable name={"Active Products"} columns={columns} tableData={data} />}
    </div>
  )
}

export default ActiveProducts
